<template>
	<Modal @close="$emit('close')" size="large">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<h3>Edit Horse</h3>
				</div>
			</div>
			<Form :horse="horse" @close="$emit('close')"/>
		</div>
	</Modal>
</template>

<script>
import Modal from './../Modal.vue'
import Form from './Form.vue'

export default {
	components: {
		Modal,
		Form
	},
	props: [
		'horse'
	]
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/Horses/Edit.vue